<template>
  <app-collapse class="mb-2">
    <app-collapse-item
      title
      :is-visible="widget.id == null"
      class="border border-grey rounded"
    >
      <template #header>
        <h5
          class="w-100 d-flex justify-content-between align-items-center mb-0"
        >
          Widget {{ index + 1 }}
          <feather-icon
            v-if="widget.id"
            size="18"
            icon="Trash2Icon"
            class="text-primary"
            @click.stop="showConfirmWidgetDelete(widget.id)"
          />
        </h5>
      </template>
      <b-col
        cols="12"
      >
        <b-form-group
          label="Displays For Showing"
        >
          <validation-provider
            #default="{ errors }"
            name="Displays For Showing"
            rules="required"
          >
            <v-select
              v-model="widget.settings.widgetMode"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="widgetModeOptions"
              :clearable="false"
              :reduce="option => option.type"
              placeholder="Select"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
      >
        <b-form-group
          label="Goal"
        >
          <validation-provider
            #default="{ errors }"
            name="Goal"
            rules="required"
          >
            <b-form-input
              v-model="widget.settings.goal"
              placeholder="Goal"
              type="number"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
      >
        <b-form-group
          label="Goal label"
        >
          <validation-provider
            #default="{ errors }"
            name="Goal label"
            rules="required"
          >
            <b-form-input
              v-model="widget.settings.goalLabel"
              placeholder="Goal label"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
      >
        <b-form-group
          label="Data Source"
        >
          <validation-provider
            #default="{ errors }"
            name="Data Source"
            rules="required"
          >
            <v-select
              v-model="widget.settings.dataSource"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="dataSourceOptions"
              label="name"
              :reduce="option => option.id"
              :clearable="false"
              placeholder="Select"
              @input="checkDataSourceGroups"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        v-if="showGroupSelection"
        cols="12"
      >
        <b-form-group
          label="Group"
        >
          <validation-provider
            #default="{ errors }"
            name="Group"
            rules="required"
          >
            <v-select
              v-model="widget.settings.groupValue"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="groupNamesOptions"
              :reduce="option => option.value"
              :clearable="false"
              placeholder="Select"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
      >
        <b-form-group
          label="Formula"
        >
          <validation-provider
            #default="{ errors }"
            name="Formula"
            rules="required"
          >
            <v-select
              v-model="widget.settings.formula"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="formulaOptions"
              :clearable="false"
              placeholder="Select"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        v-if="widget.settings.formula == 'Sum'"
        cols="12"
      >
        <b-form-group
          label="Column To Sum"
        >
          <validation-provider
            #default="{ errors }"
            name="Column To Sum"
            rules="required"
          >
            <v-select
              v-model="widget.settings.column"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="columnOptions"
              :reduce="option => option.value"
              :clearable="false"
              placeholder="Select"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

    </app-collapse-item>
  </app-collapse>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

import {
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import { widgetOptions } from '@core/mixins/widgetOptions'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,

    BCol,
    BFormGroup,
    BFormInput,

    AppCollapse,
    AppCollapseItem,
    vSelect,
  },
  mixins: [widgetOptions],
  props: {
    index: {
      type: Number,
      default: 0,
    },
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      widgetModeOptions: [
        {
          label: 'Circle progress bar',
          type: 'circle',
        },
        {
          label: 'Line progress bar',
          type: 'line',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
